import { getAmount, getTotalDeposits, Step } from '../core/utils'
import { selectUser } from 'containers/Login/loginSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Select from 'components/inputs/Select'
import { displayPrice } from 'utils/string'
import Input from 'components/inputs/Input'
import { useReduxSelector } from 'store'
import { toLongDate } from 'utils/date'
import Item from '../core/Item'
import React from 'react'

interface SummaryProps {
  selectedData: payments.SelectedData
  response?: payments.CancelRentalResponse
  selectedTimePeriods: payments.SelectedTimePeriods
  setStep: React.Dispatch<React.SetStateAction<Step>>
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
  setSelectedTimePeriods: React.Dispatch<React.SetStateAction<payments.SelectedTimePeriods>>
}

const Summary: React.FC<SummaryProps> = ({ response, selectedData, selectedTimePeriods, setStep, selectData, setSelectedTimePeriods }) => {
  const { unpaidInvoicesAmount, unpaid_invoices } = useReduxSelector(selectUser)
  const tiles = response?.warehouses?.[0]?.schedule?.[0]?.tiles
  const amount = Number(unpaidInvoicesAmount) + getAmount(selectedTimePeriods, tiles)
  const deposit = getTotalDeposits(selectedData, response?.warehouses?.[0])

  const { goBack } = useHistory()
  const { t, lang } = useTranslation('warehouse')

  return <>
    <div className='title'>
      <div>{t('payments')}</div>
      <div>{t('completeTheFormalities')}</div>
    </div>

    <div className='resignation__main'>
      <div className='resignation__list'>
        {tiles && <Select
          secondaryTheme
          value={selectedTimePeriods}
          setValue={setSelectedTimePeriods}
          label={t('whatPeriodDoYouWantToPayFor')}
          options={tiles?.map(({ accumulative_discount }, idx, arr) => {
            const period = idx + 1
            return {
              name: arr.length === period
                ? t('wholePeriod')
                : `${period} ${period === 1 ? t('month') : period < 5 ? t('months<5') : t('months>=5')}${accumulative_discount ? ` (${accumulative_discount})` : ''}`,
              value: idx
            }
          }) || []}
        />}
        <Item
          icon='calendar'
          title={t('resignationType.termination')}
          desc={toLongDate(selectedData.date, lang, true)}
        />

        <Item
          icon='payments'
          title={t('unpaidInvoices')}
          desc={`${unpaid_invoices.length} ${t('invoicesForTheAmount')}: ${displayPrice(unpaidInvoicesAmount)}`}
        />

        {deposit > 0 && <>
          <p>{t('fillInTheMissingDetailsForTheRefund')}</p>
          <Input
            name='refundName'
            label={t('recipientName')}
            placeholder={t('enterTheRecipientName')}
            value={selectedData.refundName || ''}
            changeHandler={e => {
              selectData(prev => ({ ...prev, refundName: e.target.value }))
            }}
          />
          <Input
            name='refundAccountNumber'
            label={t('bankAccountNumber')}
            placeholder={t('enterYourBankAccountNumber')}
            value={selectedData.refundAccountNumber || ''}
            changeHandler={e => {
              selectData(prev => ({ ...prev, refundAccountNumber: e.target.value }))
            }}
          />
        </>}
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          disabled={deposit > 0 && (!selectedData.refundName || !selectedData.refundAccountNumber)}
          text={amount > 0
            ? `${t('pay')} ${displayPrice(amount)}`
            : t((deposit > 0 && selectedData.refundName && selectedData.refundAccountNumber)
              ? 'save'
              : 'next')}
          action={() => {
            if (amount > 0) {
              setStep('payment')
            } else {
              goBack()
            }
          }}
        />

        <BackBtn />
      </div>
    </div>
  </>
}

export default Summary